import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SalesforceService } from '@shared/http/salesforce.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-nps-dialog',
  templateUrl: './nps-dialog.component.html',
  styleUrls: ['./nps-dialog.component.scss']
})
export class NpsDialogComponent implements OnInit {

  public isSaving = false;

  public selected: number;
  public observations: string;

  constructor(
    public dialogRef: MatDialogRef<NpsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: SalesforceService
  ) { }

  ngOnInit(): void {
  }

  public confirm() {
    this.service.registerNps(this.selected, this.observations)
    .pipe(finalize(() => {
      this.isSaving = false;
      this.dialogRef.close();
    }))
    .subscribe()
  }


}
